import { AccessTokenService } from "./AccessToken.service";
import { ApplicationService } from "./Application.service";
import { LogService } from "./Log.service";
import { NavigationService } from "./Navigation.service";

export default {
  accessTokenService: {
    class: AccessTokenService,
    public: true,
    arguments: [{ $ref: "logService" }, "applicationAccessToken"]
  },
  applicationService: {
    class: ApplicationService,
    public: true,
    arguments: [{ $ref: "apiService" }, { $ref: "userService" }]
  },
  logService: {
    class: LogService,
    public: true
  },
  navigationService: {
    class: NavigationService,
    public: true
  }
};
